import React, { Component } from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { AppAsideToggler, AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import logo from '../../assets/img/brand/logo.png'
import sygnet from '../../assets/img/brand/logo.png'
import { userActions, organizationActions } from '../../_actions';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultHeader extends Component {

  componentDidMount() {
    this.props.dispatch(organizationActions.getOrganization());
  }

  render() {

    // eslint-disable-next-line
    const { user } = this.props;

    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppNavbarBrand
          full={{ src: logo, width: 89, height: 25, alt: 'hmtg logo' }}
          minimized={{ src: sygnet, width: 30, height: 30, alt: 'hmtg logo' }}
        />
        <AppSidebarToggler className="d-md-down-none" display="lg" />
 
          <Nav className="ml-auto" navbar>
            <AppHeaderDropdown direction="down">
              <DropdownToggle nav>
                {user.firstName} {user.lastName} &nbsp;
                {user.userProfilePicture &&<img src={'https://www.w3schools.com/howto/img_avatar.png'} className="img-avatar" alt="" />}
                  <i className="fa fa-caret-down" style={{marginRight: "1em"}}></i>
              </DropdownToggle>
              <DropdownMenu right style={{ right: 'auto' }}>
                <DropdownItem href="/firma"><i className="fa fa-lock"></i>Firma</DropdownItem>
                <DropdownItem href="/logout"><i className="fa fa-lock"></i> Logout</DropdownItem>
              </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
        {/*<AppAsideToggler className="d-md-down-none" />*/}
        {/*<AppAsideToggler className="d-lg-none" mobile />*/}
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
      user
  };
}

export default connect(mapStateToProps)(DefaultHeader);
